module.exports = __webpack_public_path__ + "img/sn.7069b397.jpg";